
import sHeader from "@/components/sheader.vue"
import { trackPurchase } from "@/utils/track"
import { generateQR } from "@/utils/utils"
import { createQrPolling } from "@/utils/qrCodePolling"
import { orderInfoAfterPay } from "@/api/order.js"

export default {
  name: "OfflinePaymentCheckout",
  components: {
    sHeader
  },
  layout: "onlyFooter",
  data() {
    return {
      orderNo: "", // 订单号
      orderListStr: "", // 订单列表字符串
      qrCodeStr: "", // 二维码字符串
      showQRcodeSrc: "", // 二维码图片
      qrPolling: null, // 二维码轮询
      isPaymentRequired: true // 是否需要支付
    }
  },
  watch: {
    qrCodeStr: {
      handler(val) {
        if (val) {
          this.initQrCode(val)
        }
      }
    }
  },
  created() {
    if (!process.client) return
    const query = this.$route.query
    if (query && Object.keys(query).length) {
      this.orderNo = query.orderNo
      this.orderListStr = query.orderList
    }
  },
  mounted() {
    // 页面挂载后启动轮询
    this.initPageQrPolling()
  },
  // 页面销毁，清除定时器，防止内存泄漏
  beforeDestroy() {
    this.qrPolling?.stop()
  },
  methods: {
    requestOfflineOrderData() {
      const isFirstLoading = !this.qrCodeStr
      return orderInfoAfterPay(
        {
          param: JSON.stringify({
            orderId: this.orderNo,
            orderListStr: this.orderListStr || ""
          })
        },
        isFirstLoading
      )
        .then(res => {
          const data = res.data || {}
          if (data?.frontOrderVO) {
            trackPurchase(data.frontOrderVO)
          }
          return data
        })
        .catch(error => {
          console.error("订单查询失败", error)
          return {}
        })
    },
    initPageQrPolling() {
      this.qrPolling = createQrPolling({
        request: () => {
          return this.requestOfflineOrderData()
        },
        callback: res => {
          const { frontOrderVO } = res || {}
          const { offlinePaymentOrderInfo, orderStatus } = frontOrderVO || {}
          this.qrCodeStr = offlinePaymentOrderInfo || ""
          if (orderStatus === 9) {
            this.isPaymentRequired = false
          } else {
            this.isPaymentRequired = true
          }
        },
        isSuccess: res => {
          return res.frontOrderVO?.orderStatus === 9 // 9:支付成功
        },
        onSuccess: () => {
          this.$navigation.replace({
            path: "/payment_result",
            query: {
              orderNo: this.orderNo,
              orderList: this.orderListStr
            }
          })
        },
        onError(err) {
          console.log("onError", err)
        }
      })
      this.qrPolling?.start()
    },
    continueShopping() {
      this.$navigation.replace({
        path: "/"
      })
    },
    toViewOrder() {
      this.$navigation.replace({ name: "order_list", query: { page: 1 } })
    },
    async initQrCode(codeStr) {
      try {
        if (codeStr) {
          this.showQRcodeSrc = await generateQR(codeStr)
        }
      } catch (err) {
        console.error("轮询/生成二维码失败：", err)
      }
    },

    // 停止轮询
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    }
  }
}
